import { LockManager } from "@pdfking/tfunc"

import { GetLastError } from "../functions/GetLastError"
import { InitializePdfium } from "../functions/InitializePdfium"
import { SaveDocument } from "../functions/SaveDocument"
import type { NewDocument } from "../types/NewDocument"

const pdfium_lock = new LockManager()
const schedule = <T>(func: () => Promise<T>) => pdfium_lock.schedule(30n, func)
const schedule_iterable = <T>(stream: AsyncGenerator<T>) =>
  pdfium_lock.schedule_iterable(30n, stream)

export async function PdfDocumentNew(): Promise<NewDocument> {
  const pdfium = await schedule(InitializePdfium)

  const doc_pointer: number = await schedule(async () =>
    pdfium.FPDF_CreateNewDocument()
  )

  if (!doc_pointer) {
    const error = await schedule(async () => GetLastError(pdfium))
    throw new Error(`Failed to create new PDF document: ${error}`)
  }

  const close = async () => {
    if (doc_pointer) {
      await schedule(async () => pdfium.FPDF_CloseDocument(doc_pointer))
    }
  }

  return {
    pdfium,
    page_count: 0,
    doc_pointer,
    save(): AsyncGenerator<Blob> {
      return schedule_iterable(SaveDocument(this))
    },
    close,
  }
}
